export interface MenuSearchEntry {
  label: string
  group?: string
}

function normalize(text: string) {
  return text.toLowerCase().replace(/\s+/g, '')
}

/** 模糊打分：连续包含得分最高，其次按顺序出现的子序列（如「供发」→「供应商发票」）。不匹配返回 -1。 */
export function scoreMenuLabel(label: string, query: string): number {
  const q = normalize(query)
  const l = normalize(label)
  if (!q) return -1
  const index = l.indexOf(q)
  if (index === 0) return 100
  if (index > 0) return 80 - Math.min(index, 30)
  let pos = 0
  let gaps = 0
  for (const ch of q) {
    const found = l.indexOf(ch, pos)
    if (found < 0) return -1
    gaps += found - pos
    pos = found + 1
  }
  return Math.max(1, 40 - gaps)
}

export function searchMenu<T extends MenuSearchEntry>(entries: T[], query: string, limit = 12): T[] {
  return entries
    .map((entry, order) => ({
      entry,
      order,
      score: Math.max(scoreMenuLabel(entry.label, query), entry.group ? scoreMenuLabel(`${entry.group}${entry.label}`, query) - 5 : -1),
    }))
    .filter((item) => item.score > 0)
    .sort((a, b) => b.score - a.score || a.order - b.order)
    .slice(0, limit)
    .map((item) => item.entry)
}
